import { render, staticRenderFns } from "./AboutSwiper5.vue?vue&type=template&id=1d5d2d5a&scoped=true&"
import script from "./AboutSwiper5.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper5.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper5.vue?vue&type=style&index=0&id=1d5d2d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d2d5a",
  null
  
)

export default component.exports